var map = {
	"./ar.json": 50867,
	"./en.json": 10656,
	"./es.json": 69927,
	"./fa.json": 37316,
	"./hy.json": 6310,
	"./km.json": 22594,
	"./ko.json": 25053,
	"./ru.json": 10848,
	"./tl.json": 53011,
	"./vi.json": 31688,
	"./zh.json": 58269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61823;